// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.scss */
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.rootElement {
  min-height: 92vh !important;
}

.ePLeEU {
  font-size: 14px !important;
}

.width-40 {
  width: 40% !important;
}

.width-80 {
  width: 80% !important;
}

.width-100 {
  width: 100% !important;
}

.width-150 {
  width: 150% !important;
}

.width-200 {
  width: 200% !important;
}

.width-300 {
  width: 300% !important;
}

.width-400 {
  width: 400% !important;
}

.width-500 {
  width: 500% !important;
}

.width-150 {
  width: 150px !important;
}

.attachmentIcon {
  width: 25px;
  cursor: pointer;
}

.rowScroll {
  overflow-x: auto;
  white-space: nowrap;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--login-background-overlay-color);
}

.border-red-500 {
  border: 1px solid rgb(248, 5, 5) !important;
}

.resetPageHeader {
  z-index: 997;
  height: 60px;
  box-shadow: 0px 2px 20px rgba(1, 41, 112, 0.1);
  background-color: #131834;
  text-align: center;
  color: #fff;
  padding: 4px;
}

.addMore {
  font-weight: 600;
  cursor: pointer;
}

.addMore:hover {
  font-size: 16px;
}

.formBuildSection {
  display: flex;
  border: 1px solid #8fd737;
  border-style: dashed;
  margin-bottom: 10px;
  border-radius: 4px;
}

.modalSection {
  overflow: auto;
  height: 800px;
}

.loginBackground .innerLoginBox {
  border-radius: 10px;
  margin-top: 8vh;
}
.loginBackground .card-title,
.loginBackground label {
  color: var(--login-header-description);
}
.loginBackground .title {
  color: var(--login-header-title-color);
  font-size: 44px;
  font-weight: 600;
  font-family: "sans-serif" !important;
  z-index: 999;
}
.loginBackground .btn {
  font-weight: 600 !important;
}
.loginBackground .card {
  height: 510px;
  padding: 16px;
  background: var(--login-card-background-color) !important;
}
.loginBackground .header {
  background-color: #131834;
  box-shadow: -1px -4px 10px 4px white;
}
.loginBackground .headerTitle {
  font-size: 30px;
  padding: 2px 18px !important;
  margin: 0px;
  font-weight: 600;
  color: #fff;
}
.loginBackground .subTitle {
  font-size: 14px;
  padding: 0px 2px !important;
  margin-bottom: 0px;
  font-weight: 600;
  color: #57ef82;
  display: block;
}
.loginBackground .headerLogo {
  width: 94px;
  border-radius: 6px;
  display: inline;
  margin-right: 14px;
}
.loginBackground .loingFont {
  font-size: 16px;
}
.loginBackground .copyright {
  color: #fff;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .loginBackground .headerTitle {
    font-size: 30px;
  }
  .loginBackground .subTitle {
    font-size: 12px;
  }
  .loginBackground .title {
    font-size: 36px;
  }
  .loginBackground .copyright {
    position: relative;
    margin-top: 54px;
  }
  .btnTable {
    margin-top: 10px !important;
    width: 100% !important;
  }
  .btnSpaceInMobile {
    width: 150px;
  }
}
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
}
.bounce {
  animation: bounce 8s infinite;
}

.supplier_app {
  font-family: sans-serif, "Helvetica Neue", "Lucida Grande", Arial;
  color: #fff !important;
}

.supplier_app1 {
  font-family: sans-serif, "Helvetica Neue", "Lucida Grande", Arial;
  color: #143ba6 !important;
}

.eyeCss {
  border: 0px;
}

.timmer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0px 13px;
  margin-bottom: 26px;
  font-size: 14px;
}

.timmer2 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0px 13px;
  margin-bottom: 8px;
  font-size: 12px;
}
.timmer2 span {
  font-weight: bold;
}

.accordion-item:first-of-type .accordion-button {
  background-color: transparent !important;
}

body {
  background-color: var(--mian-body-backgroud) !important;
}

.collapse {
  visibility: initial !important;
}

.btn {
  background: var(--btn-color) !important;
  color: var(--btn-text-color) !important;
  border-color: var(--btn-border-color) !important;
  border: 1px solid;
  border-radius: 8px !important;
}
.btn i {
  color: var(--btn-text-color) !important;
}

.btn:hover {
  background: var(--btn-hover-color) !important;
}

.btnTable {
  background: var(--btn-table-color) !important;
  color: var(--btn-table-text-color) !important;
  border-color: var(--btn-table-border-color) !important;
  border: 1px solid;
  border-radius: 5px !important;
  font-size: 14px !important;
  padding: 8px;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.btnTable i {
  color: var(--btn-table-text-color) !important;
}
.btnTable span {
  color: var(--btn-table-text-color) !important;
}

.btnTable:hover {
  background: var(--btn-table-hover-color) !important;
}

.btnTable:disabled {
  opacity: 0.25;
}

.btnInfo {
  background: var(--btn-table-color) !important;
  border-color: var(--btn-table-border-color) !important;
  color: var(--btn-table-text-color) !important;
  border-radius: 20px !important;
  font-size: 12px !important;
  padding: 8px;
  border: 1px solid;
  width: 200px;
}

.btnInfo:hover {
  background: var(--btn-table-hover-color) !important;
}

.btn-primary {
  background: var(--btn-table-color) !important;
  border-color: var(--btn-table-border-color) !important;
  color: var(--btn-table-text-color) !important;
}

.btn-primary:hover {
  background: var(--btn-table-hover-color) !important;
}

.btnBack {
  background: var(--btn-table-color) !important;
  border-color: var(--btn-table-border-color) !important;
  color: var(--btn-table-text-color) !important;
  border-radius: 20px !important;
  font-size: 14px !important;
  padding: 8px;
  border: 1px solid rgba(19, 24, 52, 0.1411764706);
  width: 200px;
}

.btnBack:hover {
  background: var(--btn-table-hover-color) !important;
}

.btnApprove {
  background: #2cb92c !important;
  color: #fff !important;
  border-color: #2cb92c !important;
  border: 1px solid;
  border-radius: 5px !important;
  font-size: 14px !important;
  padding: 8px;
  width: 90%;
}
.btnApprove i {
  color: #fff !important;
}

.btnApprove:hover {
  background: #1e8b1e !important;
}

.btnApprove:disabled {
  opacity: 0.25;
}

.close-btn {
  font-size: 20px;
  color: #919191;
  cursor: pointer;
}

.close-btn:hover {
  color: #000;
}

.statusColor {
  color: #007FFF !important;
}

.iconTable {
  font-size: 20px;
  padding-right: 8px;
  cursor: pointer;
}

.iconTable:hover {
  font-size: 22px;
  background-color: #e1e3f1;
  border-radius: 8px;
  padding: 4px;
}

.iconTableNew {
  padding-right: 8px;
  cursor: pointer;
}

.iconTableNew:hover {
  background-color: #e1e3f1;
  border-radius: 8px;
  padding: 4px;
}

.suppliersIcon {
  background: var(--btn-table-color) !important;
  padding: 1px 8px;
  border-radius: 14px;
  font-size: 12px;
  font-weight: bold;
  margin-left: -12px;
  margin-top: -16px;
  border: 1px solid var(--btn-table-border-color);
  text-align: center;
  color: var(--btn-table-text-color) !important;
}

.btnCommon {
  border-radius: 20px !important;
  color: #000;
  font-size: 14px !important;
  padding: 8px;
  width: 200px;
  margin-right: 6px;
  font-weight: 600;
}

.btnCommon:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btnDelete {
  border: 1px solid;
  border-radius: 5px !important;
  font-size: 14px !important;
  padding: 8px;
  width: 90%;
  background: rgba(231, 50, 65, 0.9098039216) !important;
  border-color: rgba(231, 50, 65, 0.9098039216) !important;
  color: #fff !important;
}
.btnDelete i {
  color: var(--btn-table-text-color) !important;
}

.btnDelete:hover {
  background: rgba(219, 27, 43, 0.9098039216) !important;
}

.btn-danger {
  background: rgba(231, 50, 65, 0.9098039216) !important;
  border-color: rgba(231, 50, 65, 0.9098039216) !important;
  color: #fff !important;
}

.btn-danger:hover {
  background: rgba(219, 27, 43, 0.9098039216) !important;
}

.btn-approve {
  background: #31df71 !important;
  border-color: #18bb54 !important;
  color: #000000 !important;
}

.btn-approve:hover {
  background: #18bb54 !important;
}

.badgeExtra {
  color: #1c1b1b !important;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.btn:focus {
  box-shadow: none !important;
}

.textSuccess {
  color: #009a39;
  font-size: 18px;
  font-weight: 600;
}

.bg-success-wh {
  background-color: #22c55e !important;
}

.bg-secondary-wh {
  background-color: #bebbbb !important;
}

.bg-table-status {
  font-weight: 700;
  padding: 4px;
  border-radius: 50px;
  width: 100%;
  text-align: center;
  letter-spacing: 0.5px;
}

.bg-table-success-status {
  color: #008000;
  background-color: rgba(34, 139, 34, 0.231372549);
}

.bg-table-danger-status {
  color: #f30e2d;
  background-color: rgba(243, 14, 45, 0.231372549);
}

.bg-table-warning-status {
  color: #F17C1A;
  background-color: rgba(241, 123, 26, 0.2588235294);
}

.bg-table-info-status {
  color: rgba(85, 85, 85, 0.6980392157);
  background-color: rgba(85, 85, 85, 0.137254902);
}

.bg-table-progress-status {
  color: #FF8C00;
  background-color: rgba(255, 191, 0, 0.2666666667);
}

.bg-table-new-status {
  color: #002387;
  background-color: rgba(0, 36, 135, 0.231372549);
}

.bg-table-previous-approver-status {
  color: #577766;
  background-color: rgba(133, 176, 154, 0.2588235294);
}

.bg-table-next-approver-status {
  color: #3f7d99;
  background-color: rgba(137, 207, 240, 0.2745098039);
}

.bg-table-documentNumber-status {
  color: #fff;
  background-color: #273167;
}

.bg-table-headerTag-status {
  color: #3b2a6b;
  background-color: #d7ddff;
}

.bg-status {
  font-weight: 700;
  padding: 4px 16px;
  border-radius: 50px;
  width: 100%;
  text-align: center;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.bg-success-workflow {
  color: #008000;
  background-color: rgba(34, 139, 34, 0.231372549);
}

.bg-danger-workflow {
  color: #f30e2d;
  background-color: rgba(243, 14, 45, 0.231372549);
}

.bg-warning-workflow {
  color: #F17C1A;
  background-color: rgba(241, 123, 26, 0.2588235294);
}

.bg-info-workflow {
  color: rgba(85, 85, 85, 0.6980392157);
  background-color: rgba(85, 85, 85, 0.137254902);
}

.bg-pending-workflow {
  color: #FF8C00;
  background-color: rgba(255, 191, 0, 0.2666666667);
}

.bg-complete-workflow {
  color: #fff;
  background-color: #138808;
}

.bg-submit-workflow {
  color: #007BA7;
  background-color: #B9D9EB;
}

.bg-new-workflow {
  color: #fff;
  background-color: #008eff;
}

.headerStatusDetailedPage {
  position: relative;
  font-size: 16px;
  padding: 5px 17px;
  margin-left: 16px;
  top: -4px;
}

.headerStatusTag {
  position: relative;
  font-size: 14px;
  padding: 4px 16px;
  margin-left: 16px;
  letter-spacing: 1px;
  border-radius: 6px;
}

.workflow-remark {
  border: 1px solid #afa8a8;
  padding: 10px;
  border-radius: 5px;
  border-style: dashed;
  font-size: 12px;
  font-weight: 600;
  color: #1c449c;
}

.form-check-input:checked {
  background-color: var(--radio--background-color) !important;
  border-color: var(--radio--border-color) !important;
}

.generatedTable {
  width: 150% !important;
}
.generatedTable .tableHeader {
  font-size: 12px;
  font-weight: 700;
  background-color: #f7f7f7;
  letter-spacing: 1px;
}
.generatedTable ._01 {
  width: 60px;
  text-align: center;
}
.generatedTable ._02 {
  width: 400px;
}
.generatedTable ._03 {
  width: 150px;
}
.generatedTable ._04 {
  width: 150px;
}
.generatedTable ._05 {
  width: 150px;
}
.generatedTable td {
  font-size: 13px;
}
.generatedTable td .form-select {
  font-size: 12px;
}

.autoScroll {
  overflow: auto;
}

.tooltip-inner {
  background-color: #fff !important;
  color: #000 !important;
  border: 1px solid rgba(140, 143, 149, 0.5019607843) !important;
  max-width: 500px !important;
  width: 300px !important;
  font-size: 16px !important;
  text-align: left !important;
  box-shadow: 0px 0px 3px 0px gray;
}
.tooltip-inner p {
  margin-top: 0;
  margin-bottom: 0;
}
.tooltip-inner .itemName {
  font-size: 16px;
  font-weight: 600;
}
.tooltip-inner .textPros {
  font-size: 12px;
  font-weight: 400;
  text-align: right;
}
.tooltip-inner .rowBorder {
  border-bottom: 1px dashed #858484;
}

.header-group {
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-span {
  font-weight: bold;
  font-size: 16px;
  padding: 5px;
  background-color: #dcdcdc;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
  width: 200px;
  /* Adjust width to simulate spanning columns */
}

.tooltip.show {
  opacity: initial !important;
}

.ShowHorizontalStatus .activity-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.ShowHorizontalStatus .activity-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.ShowHorizontalStatus .activity-item .text-muted {
  font-size: 12px;
}
.ShowHorizontalStatus .activity-line {
  position: absolute;
  top: 22px;
  /* Adjust this based on icon size */
  left: 80px;
  right: 50px;
  height: 2px;
  background-color: #ccc;
  /* Line color */
  z-index: 0;
}
.ShowHorizontalStatus .activity-icon {
  z-index: 1;
  /* Ensure icons stay on top of the line */
  background-color: white;
  /* To give a border effect around the icon */
}
.ShowHorizontalStatus .activity-content {
  text-align: center;
}
.ShowHorizontalStatus .activity-content .text-break {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px !important;
}

.sidebar-nav .nav-heading {
  font-size: 14px;
  text-transform: uppercase;
  color: #000000;
  font-weight: 600;
  margin: 12px 0 5px 0px;
}

.accordion-button:focus {
  box-shadow: none !important;
}

.accordion-button:not(.collapsed) {
  background-color: #ffffff !important;
}

.accordion-header {
  margin-left: 0px;
  margin-right: 0px;
}

.accordion-item .headerTitle {
  display: block;
  font-size: 17px;
  font-weight: bold;
  padding-bottom: 4px;
}
.accordion-item .subHeaderTitle {
  display: block;
  font-size: 14px;
  font-weight: 400;
}

.accordion .refreshIcon {
  width: 80px;
  text-align: end;
  font-size: 20px;
  cursor: pointer;
}
.accordion .refreshIcon:hover {
  font-size: 22px;
}
.accordion .dropdown-menu.show {
  position: absolute !important;
  inset: 30px 0px auto -122px !important;
  margin: 0 !important;
  transform: translate(0, 0) !important;
}

.commonFooter {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: #fff;
  text-align: center;
  padding: 20px 0;
  margin-left: -2%;
}

.rowDirection {
  flex-direction: row-reverse;
}

.headerIcon {
  font-size: 18px;
  cursor: pointer;
}

.headerIcon:hover {
  color: #ceaef7;
}

.iconLogo {
  background: var(--table-icon-background-color) !important;
  font-size: 20px;
  color: var(--table-icon-text-color);
  border: 1px solid rgba(0, 0, 0, 0.11);
  border-radius: 4px;
  width: 44px;
  display: block;
  padding: 5px 0px;
}

input[type=text],
input[type=number],
input[type=date],
input[type=password],
input[type=email] {
  background-color: rgba(255, 255, 255, 0.8901960784) !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  border: 1px solid #ccc;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
span,
label,
a,
div {
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
  color: var(--app-text-color);
}

.dropdownHive input[type=text] {
  border-radius: 2px !important;
  font-size: 14px !important;
  border: 0px solid rgb(195, 185, 185) !important;
}
.dropdownHive .rw-widget-picker {
  min-height: 42px;
  border-radius: 8px;
}
.dropdownHive .rw-list-option.rw-state-selected,
.dropdownHive .rw-state-selected.rw-list-option-create {
  background-color: #aaa8a8;
  border-color: #aaa8a8;
  color: #fff;
}

.border-red-dropdown .rw-widget-picker {
  border: 1px solid rgb(248, 5, 5) !important;
}

.dropdownHiveOption {
  z-index: 9999;
}

.dropdownIcon {
  top: 23px;
}

.form-label {
  font-weight: 600;
  font-size: 14px;
}

a {
  text-decoration: none !important;
}

.subText {
  font-size: 14px;
}

.form-signin {
  text-align: center;
  margin-top: 22px;
  font-size: 16px;
  font-weight: 600;
}

.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79, 70, 229, var(--tw-text-opacity)) !important;
}

/* width */
::-webkit-scrollbar {
  width: 4px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #bec4c4;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* ===== Scrollbar CSS ===== */
/* Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: #bebbbb #ffffff;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 4px;
}

*::-webkit-scrollbar-track {
  background: #ffffff;
}

*::-webkit-scrollbar-thumb {
  background-color: #bebbbb;
  border-radius: 10px;
  border: 3px solid #ffffff;
}

.arrowBtn {
  width: 50px !important;
}

.logoBtn {
  width: 70px !important;
}

.headerText {
  font-weight: 600;
  font-size: 16px;
  margin-right: 4px;
  display: block;
}

.headerSubText {
  font-size: 16px;
}

.deleteIconAccordion {
  float: inline-end;
  margin-top: -54px;
  margin-right: 15px;
}
.deleteIconAccordion i {
  font-size: 24px;
  color: red;
  cursor: pointer;
}
.deleteIconAccordion i:hover {
  font-size: 26px;
}

.infoIconAccordion i {
  font-size: 18px;
  color: rgb(24, 33, 121);
  cursor: pointer;
}

.dynamicDropdown .rw-popup-container {
  padding: 0px !important;
  position: static !important;
}

.numberFormate {
  width: 100%;
  text-align: end;
}

.sectionArea {
  box-shadow: 0px 20px 40px 9px rgba(0, 0, 0, 0.295);
}

.navMenu {
  font-weight: 400 !important;
  text-transform: uppercase;
}

.supplier_app {
  font-family: sans-serif, "Helvetica Neue", "Lucida Grande", Arial;
  font-size: 34px;
}

.feature .learnMore {
  padding: 7px;
  background: #ff3434;
  color: #ffffff;
  font-weight: 600;
  letter-spacing: 1px;
}
.feature .textBox {
  border-left-width: 18px;
  height: 325px;
  padding-top: 35px;
  margin-right: 7%;
  padding-left: 38px;
  text-align: justify;
}

.h2 {
  margin-top: 0;
  margin-bottom: 25px;
  font-size: 60px;
  line-height: 120%;
  color: #e3f2ff;
}
.h2 .headline-emphasis-red {
  color: #e04b4d;
  font-family: Georgia, Times, Times New Roman, serif;
  font-style: italic;
  font-weight: 400;
}

.cta {
  margin-top: 0;
  margin-bottom: 25px;
  font-size: 40px;
  line-height: 120%;
}
.cta .headline-emphasis-gold {
  color: #c4a27f;
  font-family: Georgia, Times, Times New Roman, serif;
  font-style: italic;
  font-weight: 400;
}

.staffed {
  margin-top: 0;
  margin-bottom: 25px;
  font-size: 45px;
  line-height: 160%;
  color: #410641;
}

.ctaFindButton {
  background-color: rgba(251, 0, 0, 0.6117647059) !important;
}

.ctaFindButton:hover {
  background-color: #ff0000 !important;
}

.text-lgColor {
  color: #71b7b7;
}

.text-xlColor {
  color: #f7f7f7;
}

.footer .workersHiveFooter {
  text-align: right;
  position: absolute;
  padding-top: 1%;
}

.navBackground {
  background-color: #131834;
}

.introCustomerlogo {
  width: 150px;
  height: 70px !important;
}

.loginPage {
  background-color: #ffffff;
  background-image: -webkit-linear-gradient(278deg, #f3f3f3 65%, #ffffff 50%);
}
.loginPage .loadSingIn {
  animation: bounce-in 1s ease-in;
}
.loginPage .loadReset {
  animation: bounce-out 1s ease-in;
}
@keyframes bounce-in {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes bounce-out {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.5);
  }
}
.loginPage .indexValue {
  z-index: 5;
}
.loginPage .mainTitle {
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 18px;
  margin-top: 15px;
  color: #dc0000;
  text-align: center;
}
.loginPage .box2 {
  border: 1px solid #dbd6d6;
  border-radius: 3px;
  box-shadow: 0px 7px 20px 3px #b7b6b6;
  padding: 40px 40px 30px 40px;
}
.loginPage .box2 .inputBox {
  padding-left: 10px;
}
.loginPage .box2 .eyeCss {
  margin-top: 12px;
  width: 30px;
}
.loginPage .box2 .mainTitleBox2 {
  font-size: 20px;
  color: #313131;
  margin-top: 6px;
}
.loginPage .box2 .passwordEye {
  position: absolute;
  margin-left: -28px;
  margin-top: 18px;
}
.loginPage .footer {
  margin-top: 0%;
  float: left;
  font-size: 14px;
  font-weight: 600;
}
.loginPage .footer .footerLink {
  text-decoration: none;
  color: #2b2a2a;
  margin-right: 14px;
}
.loginPage .footer .footerLinkText {
  margin: 8px 13px 13px 2px;
  font-size: 12px;
  font-weight: 500;
}
.loginPage .subText {
  font-size: 13px;
}
.loginPage .staySingIn {
  font-size: 14px;
  font-weight: 600;
}
.loginPage .removeUnderline {
  cursor: pointer;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  color: #0d6efd;
  float: right;
  margin-top: -21px;
}
.loginPage .removeUnderline:hover {
  color: rgb(220, 0, 0);
}
.loginPage .singUp {
  cursor: pointer;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  color: #0d6efd;
}
.loginPage .singUp:hover {
  color: rgb(220, 0, 0);
}
.loginPage .returnSingIn {
  cursor: pointer;
  text-align: center;
  margin-top: 25px;
  font-size: 14px;
  font-weight: 600;
  color: #0d6efd;
}
.loginPage .returnSingIn:hover {
  color: rgb(220, 0, 0);
}
.loginPage .db-RegisterAndLoginBackground-background {
  z-index: 0;
  position: absolute;
  top: 530px;
  bottom: 0;
  left: 0;
  right: 0;
  transform: skewY(352deg);
}
.loginPage .db-RegisterAndLoginBackground-background .db-RegisterAndLoginBackground-firstLeftStripe {
  background: rgba(220, 0, 0, 0.78);
  height: 40px;
  top: 668px;
  left: calc(50% - 700px);
  right: calc(50% + 540px);
}
.loginPage .db-RegisterAndLoginBackground-background .db-RegisterAndLoginBackground-secondLeftStripe {
  background: rgba(13, 0, 255, 0.37);
  height: 16px;
  top: 698px;
  left: -10px;
  right: calc(50% + 405px);
}

.mailConfirmation .confirmIcon {
  font-size: 100px;
  position: absolute;
  color: #00d700;
  margin-top: -56px;
  margin-left: -42px;
}
.mailConfirmation .mainTitle {
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 18px;
  margin-top: 15px;
  color: #dc0000;
  text-align: center;
}
.mailConfirmation .box2 {
  border: 1px solid #dbd6d6;
  border-radius: 3px;
  box-shadow: 0px 7px 20px 3px #b7b6b6;
  padding: 90px 40px 30px 40px !important;
}
.mailConfirmation .box2 .mainContent {
  text-align: center;
  font-size: 26px;
  font-weight: bold;
}
.mailConfirmation .box2 .subContent {
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 32px;
}
.mailConfirmation .box2 .inputBox {
  padding-left: 10px;
}
.mailConfirmation .box2 .eyeCss {
  margin-top: 12px;
  width: 30px;
}
.mailConfirmation .box2 .mainTitleBox2 {
  font-size: 20px;
  color: #313131;
  margin-top: 6px;
}
.mailConfirmation .box2 .passwordEye {
  position: absolute;
  margin-left: -28px;
  margin-top: 18px;
}
.mailConfirmation .footer {
  margin-top: 30px;
  float: left;
  font-size: 14px;
  font-weight: 600;
}
.mailConfirmation .footer .footerLink {
  text-decoration: none;
  color: #2b2a2a;
  margin-right: 14px;
}
.mailConfirmation .footer .footerLinkText {
  margin: 8px 13px 13px 2px;
  font-size: 12px;
  font-weight: 500;
}
.mailConfirmation .db-RegisterAndLoginBackground-background {
  z-index: 0;
  position: absolute;
  top: 530px;
  bottom: 0;
  left: 0;
  right: 0;
  transform: skewY(352deg);
}
.mailConfirmation .db-RegisterAndLoginBackground-background .db-RegisterAndLoginBackground-firstLeftStripe {
  background: rgba(220, 0, 0, 0.78);
  height: 40px;
  top: 668px;
  left: calc(50% - 700px);
  right: calc(50% + 540px);
}
.mailConfirmation .db-RegisterAndLoginBackground-background .db-RegisterAndLoginBackground-secondLeftStripe {
  background: rgba(13, 0, 255, 0.37);
  height: 16px;
  top: 698px;
  left: -10px;
  right: calc(50% + 405px);
}

.registerPage .fieldErrMsg {
  font-size: 12px;
  color: #f32525 !important;
}
.registerPage .indexValue {
  z-index: 5;
}
.registerPage .logo {
  width: 150px;
}
.registerPage .mainTitle {
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 30px;
  margin-top: -36px;
}
.registerPage .mainTitleSm {
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 32px;
  margin-top: 40px;
  color: #dc0000;
  text-align: center;
}
.registerPage .box1 .boxTitle {
  font-size: 16px;
  font-weight: 600;
  margin-top: 7px;
}
.registerPage .box1 .subBoxTitle {
  font-size: 14px;
  font-weight: 500;
}
.registerPage .box2 {
  border: 1px solid #dbd6d6;
  border-radius: 3px;
  box-shadow: 0px 7px 20px 3px #b7b6b6;
  padding: 40px 40px 30px 40px;
}
.registerPage .box2 .inputBox {
  padding-left: 10px;
}
.registerPage .box2 .eyeCss {
  margin-top: 12px;
  width: 30px;
}
.registerPage .box2 .mainTitleBox2 {
  color: #313131;
  margin-top: 6px;
}
.registerPage .footer {
  margin-top: 12%;
  float: left;
  font-size: 14px;
  font-weight: 600;
}
.registerPage .footer .footerLink {
  text-decoration: none;
  color: #2b2a2a;
  margin: 13px;
}
.registerPage .footer .footerLinkText {
  margin: 3px 13px 13px 15px;
  font-size: 12px;
  font-weight: 500;
}
.registerPage .singIn {
  text-decoration: none;
}
.registerPage .db-RegisterAndLoginBackground-background {
  z-index: 0;
  position: absolute;
  top: 530px;
  bottom: 0;
  left: 0;
  right: 0;
  transform: skewY(352deg);
}
.registerPage .db-RegisterAndLoginBackground-background .db-RegisterAndLoginBackground-firstLeftStripe {
  background: rgba(220, 0, 0, 0.78);
  height: 40px;
  top: 668px;
  left: calc(50% - 700px);
  right: calc(50% + 540px);
}
.registerPage .db-RegisterAndLoginBackground-background .db-RegisterAndLoginBackground-secondLeftStripe {
  background: rgba(13, 0, 255, 0.37);
  height: 16px;
  top: 698px;
  left: -10px;
  right: calc(50% + 405px);
}

/* 3D tower loader made by: csozi | Website: www.csozi.hu*/
.dots-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  margin-top: 150px;
}

.dot {
  height: 20px;
  width: 20px;
  margin-right: 10px;
  border-radius: 10px;
  background-color: #b3d4fc;
  animation: pulse 1.5s infinite ease-in-out;
}

.dot:last-child {
  margin-right: 0;
}

.dot:nth-child(1) {
  animation-delay: -0.3s;
}

.dot:nth-child(2) {
  animation-delay: -0.1s;
}

.dot:nth-child(3) {
  animation-delay: 0.1s;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    background-color: #b3d4fc;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }
  50% {
    transform: scale(1.2);
    background-color: #6793fb;
    box-shadow: 0 0 0 10px rgba(178, 212, 252, 0);
  }
  100% {
    transform: scale(0.8);
    background-color: #b3d4fc;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }
}
.accordion .accordion-header .bi-chevron-right,
.accordion .accordion-header .bi-chevron-down {
  font-size: 24px;
  cursor: pointer;
}
.accordion .accordion-collapse {
  display: none;
  transition: all 0.5s ease-in-out;
}
.accordion .accordion-collapse.visible {
  display: block;
  transition: all 0.5s ease-in-out;
}

.filterIcon {
  font-size: 45px;
  justify-content: flex-end;
  display: flex;
  color: #008ffb;
  cursor: pointer;
}

.filterIcon:hover {
  font-size: 46px;
  color: #034679;
}

.filterBox {
  border: 1px solid #8c8686;
  border-radius: 8px;
  padding: 18px 16px 0px 16px;
  border-style: dashed;
  margin-bottom: 20px;
  background-color: #ffffff;
  box-shadow: 0px 1px 9px 1px #b7b7b7;
}

.dashboard-navigate-icon {
  font-size: 32px;
  position: absolute;
  top: 96px;
  right: 10px;
  color: #3457D5;
  cursor: pointer;
}

.dashboard-navigate-icon:hover {
  color: #318CE7;
}

.loader-small .loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}
.loader-small .loader__circle {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin: 0 4px;
  animation: loader_901 1s ease-in-out infinite;
}
.loader-small .loader__circle:nth-of-type(1) {
  background-color: #007aff;
  animation-delay: 0;
}
.loader-small .loader__circle:nth-of-type(2) {
  background-color: #ff2d55;
  animation-delay: 0.25s;
}
.loader-small .loader__circle:nth-of-type(3) {
  background-color: #34c759;
  animation-delay: 0.5s;
}
.loader-small .loader__circle:nth-of-type(4) {
  background-color: #ff9500;
  animation-delay: 0.75s;
}
@keyframes loader_901 {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(1.2);
  }
  40% {
    transform: scale(1);
  }
}

.fileUploadedList {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  background-color: #b7dbff;
  padding: 2px 10px;
  border-radius: 16px;
}

.fileRemoveIcon {
  font-size: 18px;
  cursor: pointer;
  color: #ff0000;
}

.fileChoose {
  margin-bottom: 8px;
  border: 1px solid rgba(195, 185, 185, 0.568627451);
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
}

.fileChoose:hover {
  background-color: #dae6f3;
}

.fileChooseDisabled {
  margin-bottom: 8px;
  border: 1px solid rgba(195, 185, 185, 0.568627451);
  padding: 8px;
  border-radius: 8px;
  background-color: #e9ecef;
}

.fileDownload {
  font-size: 20px;
  float: right;
  margin-right: 36px;
}

.pac-container {
  width: 100% !important; /* Full width inside its parent */
  max-width: 594px !important; /* Limit max width */
  position: absolute !important;
  left: 877px !important;
  top: 2030px !important;
  z-index: 9999; /* Ensure it appears on top */
  background-color: white; /* White background for better visibility */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* Subtle shadow */
  border-radius: 4px; /* Slight rounding of edges */
  padding: 10px; /* Padding for better content spacing */
}`, "",{"version":3,"sources":["webpack://./src/common.scss"],"names":[],"mappings":"AAEA,gBAAA;AAGA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAFF;;AAKA;EACE,2BAAA;AAFF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,qBAAA;AAHF;;AAMA;EACE,qBAAA;AAHF;;AAMA;EACE,sBAAA;AAHF;;AAMA;EACE,sBAAA;AAHF;;AAMA;EACE,sBAAA;AAHF;;AAMA;EACE,sBAAA;AAHF;;AAMA;EACE,sBAAA;AAHF;;AAMA;EACE,sBAAA;AAHF;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,WAAA;EACA,eAAA;AAHF;;AAMA;EACE,gBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;AAHF;;AAMA;EACE,2CAAA;AAHF;;AAMA;EACE,YAAA;EACA,YAAA;EACA,8CAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAHF;;AAMA;EACE,gBAAA;EACA,eAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE,aAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,cAAA;EACA,aAAA;AAHF;;AAQE;EACE,mBAAA;EACA,eAAA;AALJ;AAQE;;EAEE,sCAAA;AANJ;AASE;EACE,sCAAA;EAEA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,YAAA;AARJ;AAWE;EACE,2BAAA;AATJ;AAYE;EACE,aAAA;EACA,aAAA;EACA,yDAAA;AAVJ;AAaE;EACE,yBAAA;EACA,oCAAA;AAXJ;AAcE;EACE,eAAA;EACA,4BAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;AAZJ;AAeE;EACE,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAbJ;AAgBE;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,eAAA;AAfJ;AAkBE;EAEE,WAAA;AAjBJ;;AA2BA,iDAAA;AACA;EAGI;IACE,eAAA;EA1BJ;EA6BE;IACE,eAAA;EA3BJ;EA8BE;IACE,eAAA;EA5BJ;EA+BE;IACE,kBAAA;IACA,gBAAA;EA7BJ;EAiCA;IACE,2BAAA;IACA,sBAAA;EA/BF;EAkCA;IACE,YAAA;EAhCF;AACF;AAoCA;EAEE;IAKE,wBAAA;EAvCF;EA0CA;IACE,4BAAA;EAxCF;EA2CA;IACE,4BAAA;EAzCF;AACF;AA4CA;EACE,6BAAA;AA1CF;;AAgDA;EACE,iEAAA;EACA,sBAAA;AA7CF;;AAgDA;EACE,iEAAA;EACA,yBAAA;AA7CF;;AAiDA;EACE,WAAA;AA9CF;;AAiDA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AA9CF;;AAiDA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AA9CF;AAgDE;EACE,iBAAA;AA9CJ;;AAkDA;EACE,wCAAA;AA/CF;;AAmDA;EAGE,uDAAA;AAlDF;;AAqDA;EACE,8BAAA;AAlDF;;AAsDA;EACE,uCAAA;EACA,uCAAA;EACA,gDAAA;EACA,iBAAA;EACA,6BAAA;AAnDF;AAqDE;EACE,uCAAA;AAnDJ;;AAuDA;EACE,6CAAA;AApDF;;AAuDA;EACE,6CAAA;EACA,6CAAA;EACA,sDAAA;EACA,iBAAA;EACA,6BAAA;EACA,0BAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;AApDF;AAsDE;EACE,6CAAA;AApDJ;AAsDE;EACE,6CAAA;AApDJ;;AAwDA;EACE,mDAAA;AArDF;;AAwDA;EACE,aAAA;AArDF;;AAwDA;EACE,6CAAA;EACA,sDAAA;EACA,6CAAA;EACA,8BAAA;EACA,0BAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;AArDF;;AAwDA;EACE,mDAAA;AArDF;;AAwDA;EACE,6CAAA;EACA,sDAAA;EACA,6CAAA;AArDF;;AAwDA;EACE,mDAAA;AArDF;;AAwDA;EACE,6CAAA;EACA,sDAAA;EACA,6CAAA;EACA,8BAAA;EACA,0BAAA;EACA,YAAA;EACA,gDAAA;EACA,YAAA;AArDF;;AAwDA;EACE,mDAAA;AArDF;;AAwDA;EACE,8BAAA;EACA,sBAAA;EACA,gCAAA;EACA,iBAAA;EACA,6BAAA;EACA,0BAAA;EACA,YAAA;EACA,UAAA;AArDF;AAuDE;EACE,sBAAA;AArDJ;;AAyDA;EACE,8BAAA;AAtDF;;AAyDA;EACE,aAAA;AAtDF;;AA2DA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAxDF;;AA2DA;EACE,WAAA;AAxDF;;AA2DA;EACE,yBAAA;AAxDF;;AA2DA;EACE,eAAA;EACA,kBAAA;EACA,eAAA;AAxDF;;AA2DA;EACE,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAxDF;;AA2DA;EACE,kBAAA;EACA,eAAA;AAxDF;;AA2DA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;AAxDF;;AA2DA;EACE,6CAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+CAAA;EACA,kBAAA;EACA,6CAAA;AAxDF;;AA4DA;EACE,8BAAA;EACA,WAAA;EACA,0BAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,YAAA;EACA,mBAAA;AAzDF;;AA+DA;EAIE,iBAAA;EACA,6BAAA;EACA,0BAAA;EACA,YAAA;EACA,UAAA;EACA,sDAAA;EACA,wDAAA;EACA,sBAAA;AA/DF;AAiEE;EACE,6CAAA;AA/DJ;;AAmEA;EACE,sDAAA;AAhEF;;AAmEA;EACE,sDAAA;EACA,wDAAA;EACA,sBAAA;AAhEF;;AAmEA;EACE,sDAAA;AAhEF;;AAoEA;EACE,8BAAA;EACA,gCAAA;EACA,yBAAA;AAjEF;;AAoEA;EACE,8BAAA;AAjEF;;AAoEA;EACE,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAjEF;;AAoEA;EACE,2BAAA;AAjEF;;AAoEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAjEF;;AAoEA;EACE,oCAAA;AAjEF;;AAoEA;EACE,oCAAA;AAjEF;;AAqEA;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EAEA,qBAAA;AAnEF;;AAsEA;EACE,cAAA;EACA,gDAAA;AAnEF;;AAsEA;EACE,cAAA;EACA,gDAAA;AAnEF;;AAsEA;EACE,cAAA;EACA,kDAAA;AAnEF;;AAsEA;EACE,qCAAA;EACA,+CAAA;AAnEF;;AAsEA;EACE,cAAA;EACA,iDAAA;AAnEF;;AAsEA;EACE,cAAA;EACA,+CAAA;AAnEF;;AAsEA;EACE,cAAA;EACA,mDAAA;AAnEF;;AAsEA;EACE,cAAA;EACA,mDAAA;AAnEF;;AAsEA;EACE,WAAA;EACA,yBAAA;AAnEF;;AAsEA;EACE,cAAA;EACA,yBAAA;AAnEF;;AAuEA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AApEF;;AAwEA;EACE,cAAA;EACA,gDAAA;AArEF;;AAwEA;EACE,cAAA;EACA,gDAAA;AArEF;;AAwEA;EACE,cAAA;EACA,kDAAA;AArEF;;AAwEA;EACE,qCAAA;EACA,+CAAA;AArEF;;AAwEA;EACE,cAAA;EACA,iDAAA;AArEF;;AAwEA;EACE,WAAA;EACA,yBAAA;AArEF;;AAwEA;EACE,cAAA;EACA,yBAAA;AArEF;;AAwEA;EACE,WAAA;EACA,yBAAA;AArEF;;AAwEA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;AArEF;;AAwEA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AArEF;;AAyEA;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAtEF;;AA0EA;EACE,2DAAA;EACA,mDAAA;AAvEF;;AA2EA;EACE,sBAAA;AAxEF;AA0EE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAxEJ;AA2EE;EACE,WAAA;EACA,kBAAA;AAzEJ;AA4EE;EACE,YAAA;AA1EJ;AA6EE;EACE,YAAA;AA3EJ;AA8EE;EACE,YAAA;AA5EJ;AA+EE;EACE,YAAA;AA7EJ;AAgFE;EACE,eAAA;AA9EJ;AAgFI;EACE,eAAA;AA9EN;;AAmFA;EACE,cAAA;AAhFF;;AAmFA;EACE,iCAAA;EACA,sBAAA;EACA,8DAAA;EACA,2BAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,gCAAA;AAhFF;AAkFE;EACE,aAAA;EACA,gBAAA;AAhFJ;AAmFE;EACE,eAAA;EACA,gBAAA;AAjFJ;AAoFE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAlFJ;AAqFE;EACE,iCAAA;AAnFJ;;AAuFA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AApFF;;AAuFA;EACE,iBAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,8CAAA;AApFF;;AAuFA;EACE,2BAAA;AApFF;;AAyFE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAtFJ;AAyFE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAvFJ;AAyFI;EACE,eAAA;AAvFN;AA2FE;EACE,kBAAA;EACA,SAAA;EACA,mCAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;EACA,UAAA;AAzFJ;AA4FE;EACE,UAAA;EACA,yCAAA;EACA,uBAAA;EACA,4CAAA;AA1FJ;AA6FE;EACE,kBAAA;AA3FJ;AA6FI;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;AA3FN;;AAqGA;EACE,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AAlGF;;AAsGA;EACE,2BAAA;AAnGF;;AAsGA;EACE,oCAAA;AAnGF;;AAsGA;EACE,gBAAA;EACA,iBAAA;AAnGF;;AAuGE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AApGJ;AAuGE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AArGJ;;AA0GE;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;AAvGJ;AA0GE;EACE,eAAA;AAxGJ;AA2GE;EACE,6BAAA;EACA,sCAAA;EACA,oBAAA;EACA,qCAAA;AAzGJ;;AA6GA;EACE,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA1GF;;AA6GA;EACE,2BAAA;AA1GF;;AA6GA;EACE,eAAA;EACA,eAAA;AA1GF;;AA6GA;EACE,cAAA;AA1GF;;AA6GA;EACE,yDAAA;EACA,eAAA;EACA,mCAAA;EACA,qCAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AA1GF;;AAyHA;;;;;EAKE,8DAAA;EACA,6BAAA;EACA,0BAAA;EACA,sBAAA;AAtHF;;AA0HA;;;;;;;;;;;EAWE,uNAAA;EAGA,4BAAA;AAzHF;;AA6HE;EAEE,6BAAA;EACA,0BAAA;EACA,+CAAA;AA3HJ;AA8HE;EACE,gBAAA;EACA,kBAAA;AA5HJ;AA+HE;;EAEE,yBAAA;EACA,qBAAA;EACA,WAAA;AA7HJ;;AAkIE;EACE,2CAAA;AA/HJ;;AAmIA;EACE,aAAA;AAhIF;;AAmIA;EACE,SAAA;AAhIF;;AAmIA;EACE,gBAAA;EACA,eAAA;AAhIF;;AAmIA;EACE,gCAAA;AAhIF;;AAsIA;EACE,eAAA;AAnIF;;AAsIA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAnIF;;AAsIA;EACE,oBAAA;EACA,0DAAA;AAnIF;;AAsIA,UAAA;AACA;EACE,UAAA;AAnIF;;AAsIA,UAAA;AACA;EACE,mBAAA;AAnIF;;AAsIA,WAAA;AACA;EACE,mBAAA;AAnIF;;AAsIA,oBAAA;AACA;EACE,gBAAA;AAnIF;;AAsIA,8BAAA;AACA,YAAA;AACA;EACE,qBAAA;EACA,gCAAA;AAnIF;;AAsIA,6BAAA;AACA;EACE,UAAA;AAnIF;;AAsIA;EACE,mBAAA;AAnIF;;AAsIA;EACE,yBAAA;EACA,mBAAA;EACA,yBAAA;AAnIF;;AAsIA;EACE,sBAAA;AAnIF;;AAsIA;EACE,sBAAA;AAnIF;;AAuIA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AApIF;;AAuIA;EACE,eAAA;AApIF;;AAuIA;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AApIF;AAqIE;EACE,eAAA;EACA,UAAA;EACA,eAAA;AAnIJ;AAsIE;EACE,eAAA;AApIJ;;AAyIE;EACE,eAAA;EACA,uBAAA;EACA,eAAA;AAtIJ;;AA2IE;EACE,uBAAA;EACA,2BAAA;AAxIJ;;AA4IA;EACE,WAAA;EACA,eAAA;AAzIF;;AAgJA;EACE,kDAAA;AA7IF;;AAgJA;EACE,2BAAA;EACA,yBAAA;AA7IF;;AAgJA;EACE,iEAAA;EACA,eAAA;AA7IF;;AAiJE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AA9IJ;AAiJE;EACE,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA/IJ;;AAmJA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhJF;AAkJE;EACE,cAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;AAhJJ;;AAoJA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAjJF;AAmJE;EACE,cAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;AAjJJ;;AAqJA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAlJF;;AAqJA;EACE,0DAAA;AAlJF;;AAqJA;EACE,oCAAA;AAlJF;;AAqJA;EACE,cAAA;AAlJF;;AAqJA;EACE,cAAA;AAlJF;;AAuJE;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;AApJJ;;AAyJA;EACE,yBAAA;AAtJF;;AAyJA;EACE,YAAA;EACA,uBAAA;AAtJF;;AA0JA;EACE,yBAAA;EACA,2EAAA;AAvJF;AAyJE;EACE,+BAAA;AAvJJ;AA0JE;EACE,gCAAA;AAxJJ;AA2JE;EACE;IACE,UAAA;IACA,qBAAA;EAzJJ;EA4JE;IACE,UAAA;IACA,mBAAA;EA1JJ;AACF;AA6JE;EACE;IACE,UAAA;IACA,mBAAA;EA3JJ;EA8JE;IACE,UAAA;IACA,qBAAA;EA5JJ;AACF;AA+JE;EACE,UAAA;AA7JJ;AAgKE;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA9JJ;AAiKE;EACE,yBAAA;EACA,kBAAA;EACA,oCAAA;EACA,4BAAA;AA/JJ;AAiKI;EACE,kBAAA;AA/JN;AAkKI;EACE,gBAAA;EACA,WAAA;AAhKN;AAmKI;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAjKN;AAoKI;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;AAlKN;AAsKE;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AApKJ;AAsKI;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;AApKN;AAuKI;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AArKN;AAyKE;EACE,eAAA;AAvKJ;AA0KE;EACE,eAAA;EACA,gBAAA;AAxKJ;AA2KE;EACE,eAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;AAzKJ;AA4KE;EACE,qBAAA;AA1KJ;AA6KE;EACE,eAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA3KJ;AA8KE;EACE,qBAAA;AA5KJ;AA+KE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA7KJ;AAgLE;EACE,qBAAA;AA9KJ;AAiLE;EACE,UAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,wBAAA;AA/KJ;AAiLI;EACE,iCAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,wBAAA;AA/KN;AAkLI;EACE,kCAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;AAhLN;;AAyLE;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAtLJ;AAyLE;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAvLJ;AA0LE;EACE,yBAAA;EACA,kBAAA;EACA,oCAAA;EACA,uCAAA;AAxLJ;AA0LI;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;AAxLN;AA2LI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAzLN;AA4LI;EACE,kBAAA;AA1LN;AA6LI;EACE,gBAAA;EACA,WAAA;AA3LN;AA8LI;EACE,eAAA;EACA,cAAA;EACA,eAAA;AA5LN;AA+LI;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;AA7LN;AAiME;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AA/LJ;AAiMI;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;AA/LN;AAkMI;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AAhMN;AAoME;EACE,UAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,wBAAA;AAlMJ;AAoMI;EACE,iCAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,wBAAA;AAlMN;AAqMI;EACE,kCAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;AAnMN;;AA8ME;EACE,eAAA;EACA,yBAAA;AA3MJ;AA8ME;EACE,UAAA;AA5MJ;AA+ME;EACE,YAAA;AA7MJ;AAgNE;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AA9MJ;AAiNE;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA/MJ;AAmNI;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAjNN;AAoNI;EACE,eAAA;EACA,gBAAA;AAlNN;AAsNE;EACE,yBAAA;EACA,kBAAA;EACA,oCAAA;EACA,4BAAA;AApNJ;AAsNI;EACE,kBAAA;AApNN;AAuNI;EACE,gBAAA;EACA,WAAA;AArNN;AAwNI;EACE,cAAA;EACA,eAAA;AAtNN;AA0NE;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAxNJ;AA0NI;EACE,qBAAA;EACA,cAAA;EACA,YAAA;AAxNN;AA2NI;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;AAzNN;AA6NE;EACE,qBAAA;AA3NJ;AA8NE;EACE,UAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,wBAAA;AA5NJ;AA8NI;EACE,iCAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,wBAAA;AA5NN;AA+NI;EACE,kCAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;AA7NN;;AAmOA,0DAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAjOF;;AAoOA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0CAAA;AAjOF;;AAoOA;EACE,eAAA;AAjOF;;AAoOA;EACE,sBAAA;AAjOF;;AAoOA;EACE,sBAAA;AAjOF;;AAoOA;EACE,qBAAA;AAjOF;;AAoOA;EACE;IACE,qBAAA;IACA,yBAAA;IACA,4CAAA;EAjOF;EAoOA;IACE,qBAAA;IACA,yBAAA;IACA,6CAAA;EAlOF;EAqOA;IACE,qBAAA;IACA,yBAAA;IACA,4CAAA;EAnOF;AACF;AAyOI;;EAEE,eAAA;EACA,eAAA;AAvON;AA2OE;EACE,aAAA;EACA,gCAAA;AAzOJ;AA4OE;EACE,cAAA;EACA,gCAAA;AA1OJ;;AA+OA;EACE,eAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AA5OF;;AA8OA;EACE,eAAA;EACA,cAAA;AA3OF;;AA6OA;EACE,yBAAA;EACA,kBAAA;EACA,2BAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mCAAA;AA1OF;;AA4OA;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AAzOF;;AA2OA;EACE,cAAA;AAxOF;;AA6OE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AA1OJ;AA6OE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,6CAAA;AA3OJ;AA8OE;EACE,yBAAA;EACA,kBAAA;AA5OJ;AA+OE;EACE,yBAAA;EACA,sBAAA;AA7OJ;AAgPE;EACE,yBAAA;EACA,qBAAA;AA9OJ;AAiPE;EACE,yBAAA;EACA,sBAAA;AA/OJ;AAkPE;EACE;IACE,mBAAA;EAhPJ;EAmPE;IACE,qBAAA;EAjPJ;EAoPE;IACE,mBAAA;EAlPJ;AACF;;AAsPA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;AAnPF;;AAsPA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AAnPF;;AAsPA;EACE,kBAAA;EACA,kDAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAnPF;;AAqPA;EACE,yBAAA;AAlPF;;AAqPA;EACE,kBAAA;EACA,kDAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAlPF;;AAoPA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;AAjPF;;AAoPA;EACE,sBAAA,EAAA,iCAAA;EACA,2BAAA,EAAA,oBAAA;EACA,6BAAA;EAGA,sBAAA;EACA,sBAAA;EACA,aAAA,EAAA,6BAAA;EACA,uBAAA,EAAA,2CAAA;EACA,wCAAA,EAAA,kBAAA;EACA,kBAAA,EAAA,6BAAA;EACA,aAAA,EAAA,uCAAA;AAnPF","sourcesContent":["// Common App CSS\n\n/* styles.scss */\n@import './variables.css';\n\n.ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n\n.rootElement {\n  min-height: 92vh !important;\n}\n\n// Datatable font size\n.ePLeEU {\n  font-size: 14px !important;\n}\n\n.width-40 {\n  width: 40% !important;\n}\n\n.width-80 {\n  width: 80% !important;\n}\n\n.width-100 {\n  width: 100% !important;\n}\n\n.width-150 {\n  width: 150% !important;\n}\n\n.width-200 {\n  width: 200% !important;\n}\n\n.width-300 {\n  width: 300% !important;\n}\n\n.width-400 {\n  width: 400% !important;\n}\n\n.width-500 {\n  width: 500% !important;\n}\n\n.width-150 {\n  width: 150px !important;\n}\n\n.attachmentIcon{\n  width: 25px;\n  cursor: pointer;\n}\n\n.rowScroll{\n  overflow-x: auto;\n  white-space: nowrap;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: var(--login-background-overlay-color);\n}\n\n.border-red-500{\n  border: 1px solid rgb(248, 5, 5) !important;\n}\n\n.resetPageHeader{\n  z-index: 997;\n  height: 60px;\n  box-shadow: 0px 2px 20px rgba(1, 41, 112, 0.1);\n  background-color: #131834;\n  text-align: center;\n  color: #fff;\n  padding: 4px;\n}\n\n.addMore {\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.addMore:hover {\n  font-size: 16px;\n}\n\n.formBuildSection {\n  display: flex;\n  border: 1px solid #8fd737;\n  border-style: dashed;\n  margin-bottom: 10px;\n  border-radius: 4px;\n}\n\n.modalSection {\n  overflow: auto;\n  height: 800px;\n}\n\n.loginBackground {\n\n  .innerLoginBox {\n    border-radius: 10px;\n    margin-top: 8vh;\n  }\n\n  .card-title,\n  label {\n    color: var(--login-header-description);\n  }\n\n  .title {\n    color: var(--login-header-title-color);\n    // text-align: center;\n    font-size: 44px;\n    font-weight: 600;\n    font-family: \"sans-serif\" !important;\n    z-index: 999;\n  }\n\n  .btn {\n    font-weight: 600 !important;\n  }\n\n  .card {\n    height: 510px;\n    padding: 16px;\n    background: var(--login-card-background-color) !important;\n  }\n\n  .header {\n    background-color: #131834;\n    box-shadow: -1px -4px 10px 4px white;\n  }\n\n  .headerTitle {\n    font-size: 30px;\n    padding: 2px 18px !important;\n    margin: 0px;\n    font-weight: 600;\n    color: #fff;\n  }\n\n  .subTitle {\n    font-size: 14px;\n    padding: 0px 2px !important;\n    margin-bottom: 0px;\n    font-weight: 600;\n    color: #57ef82;\n    display: block;\n  }\n\n  .headerLogo {\n    width: 94px;\n    border-radius: 6px;\n    display: inline;\n    margin-right: 14px;\n  }\n\n  .loingFont {\n    font-size: 16px;\n  }\n\n  .copyright {\n    // position: absolute;\n    color: #fff;\n    // margin-top: 100px;\n  }\n\n  // .showhideImg{\n  //   display: block;\n  // }\n}\n\n// Mobile\n/* Extra small devices (phones, 600px and down) */\n@media only screen and (max-width: 600px) {\n\n  .loginBackground {\n    .headerTitle {\n      font-size: 30px;\n    }\n\n    .subTitle {\n      font-size: 12px;\n    }\n\n    .title {\n      font-size: 36px;\n    }\n\n    .copyright {\n      position: relative;\n      margin-top: 54px;\n    }\n  }\n\n  .btnTable {\n    margin-top: 10px !important;\n    width: 100% !important;\n  }\n\n  .btnSpaceInMobile {\n    width: 150px;\n  }\n}\n\n\n@keyframes bounce {\n\n  0%,\n  20%,\n  50%,\n  80%,\n  100% {\n    transform: translateY(0);\n  }\n\n  40% {\n    transform: translateY(-30px);\n  }\n\n  60% {\n    transform: translateY(-15px);\n  }\n}\n\n.bounce {\n  animation: bounce 8s infinite;\n}\n\n// ------------------------------------------------------------------------- //\n\n// Common text logo Color\n.supplier_app {\n  font-family: sans-serif, \"Helvetica Neue\", \"Lucida Grande\", Arial;\n  color: #fff !important;\n}\n\n.supplier_app1 {\n  font-family: sans-serif, \"Helvetica Neue\", \"Lucida Grande\", Arial;\n  color: #143ba6 !important;\n}\n\n\n.eyeCss {\n  border: 0px;\n}\n\n.timmer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 0px 13px;\n  margin-bottom: 26px;\n  font-size: 14px;\n}\n\n.timmer2 {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 0px 13px;\n  margin-bottom: 8px;\n  font-size: 12px;\n\n  span {\n    font-weight: bold;\n  }\n}\n\n.accordion-item:first-of-type .accordion-button {\n  background-color: transparent !important;\n}\n\n// Common Background Color\nbody {\n  //background-image: linear-gradient(45deg, rgba(255, 255, 255, 1), rgba(252, 245, 246, 1), rgba(254, 254, 254, 1), rgba(235, 236, 238, 1), rgba(225, 227, 229, 1)) !important;\n  // min-height: 100vh!important;\n  background-color: var(--mian-body-backgroud) !important;\n}\n\n.collapse {\n  visibility: initial !important;\n}\n\n// Common Button Color\n.btn {\n  background: var(--btn-color) !important;\n  color: var(--btn-text-color) !important;\n  border-color: var(--btn-border-color) !important;\n  border: 1px solid;\n  border-radius: 8px !important;\n\n  i {\n    color: var(--btn-text-color) !important;\n  }\n}\n\n.btn:hover {\n  background: var(--btn-hover-color) !important;\n}\n\n.btnTable {\n  background: var(--btn-table-color) !important;\n  color: var(--btn-table-text-color) !important;\n  border-color: var(--btn-table-border-color) !important;\n  border: 1px solid;\n  border-radius: 5px !important;\n  font-size: 14px !important;\n  padding: 8px;\n  width: 90%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  \n  i {\n    color: var(--btn-table-text-color) !important;\n  }\n  span {\n    color: var(--btn-table-text-color) !important;\n  }\n}\n\n.btnTable:hover {\n  background: var(--btn-table-hover-color) !important;\n}\n\n.btnTable:disabled {\n  opacity: 0.25;\n}\n\n.btnInfo {\n  background: var(--btn-table-color) !important;\n  border-color: var(--btn-table-border-color) !important;\n  color: var(--btn-table-text-color) !important;\n  border-radius: 20px !important;\n  font-size: 12px !important;\n  padding: 8px;\n  border: 1px solid;\n  width: 200px;\n}\n\n.btnInfo:hover {\n  background: var(--btn-table-hover-color) !important;\n}\n\n.btn-primary {\n  background: var(--btn-table-color) !important;\n  border-color: var(--btn-table-border-color) !important;\n  color: var(--btn-table-text-color) !important;\n}\n\n.btn-primary:hover {\n  background: var(--btn-table-hover-color) !important;\n}\n\n.btnBack {\n  background: var(--btn-table-color) !important;\n  border-color: var(--btn-table-border-color) !important;\n  color: var(--btn-table-text-color) !important;\n  border-radius: 20px !important;\n  font-size: 14px !important;\n  padding: 8px;\n  border: 1px solid #13183424;\n  width: 200px;\n}\n\n.btnBack:hover {\n  background: var(--btn-table-hover-color) !important;\n}\n\n.btnApprove {\n  background: #2cb92c !important;\n  color: #fff !important;\n  border-color: #2cb92c !important;\n  border: 1px solid;\n  border-radius: 5px !important;\n  font-size: 14px !important;\n  padding: 8px;\n  width: 90%;\n\n  i {\n    color: #fff !important;\n  }\n}\n\n.btnApprove:hover {\n  background: #1e8b1e !important;\n}\n\n.btnApprove:disabled {\n  opacity: 0.25;\n}\n\n\n\n.close-btn {\n  font-size: 20px;\n  color: #919191;\n  cursor: pointer;\n}\n\n.close-btn:hover {\n  color: #000;\n}\n\n.statusColor {\n  color: #007FFF !important;\n}\n\n.iconTable {\n  font-size: 20px;\n  padding-right: 8px;\n  cursor: pointer;\n}\n\n.iconTable:hover {\n  font-size: 22px;\n  background-color: #e1e3f1;\n  border-radius: 8px;\n  padding: 4px;\n}\n\n.iconTableNew {\n  padding-right: 8px;\n  cursor: pointer;\n}\n\n.iconTableNew:hover {\n  background-color: #e1e3f1;\n  border-radius: 8px;\n  padding: 4px;\n}\n\n.suppliersIcon {\n  background: var(--btn-table-color) !important;\n  padding: 1px 8px;\n  border-radius: 14px;\n  font-size: 12px;\n  font-weight: bold;\n  margin-left: -12px;\n  margin-top: -16px;\n  border: 1px solid var(--btn-table-border-color);\n  text-align: center;\n  color: var(--btn-table-text-color) !important;\n}\n\n// Common Delete/Approve Button Color\n.btnCommon {\n  border-radius: 20px !important;\n  color: #000;\n  font-size: 14px !important;\n  padding: 8px;\n  width: 200px;\n  margin-right: 6px;\n  font-weight: 600;\n}\n\n.btnCommon:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n\n// Delete\n\n.btnDelete {\n  // background: var(--btn-table-color) !important;\n  // color: var(--btn-table-text-color) !important;\n  // border-color: var(--btn-table-border-color) !important;\n  border: 1px solid;\n  border-radius: 5px !important;\n  font-size: 14px !important;\n  padding: 8px;\n  width: 90%;\n  background: #e73241e8 !important;\n  border-color: #e73241e8 !important;\n  color: #fff !important;\n\n  i {\n    color: var(--btn-table-text-color) !important;\n  }\n}\n\n.btnDelete:hover {\n  background: #db1b2be8 !important;\n}\n\n.btn-danger {\n  background: #e73241e8 !important;\n  border-color: #e73241e8 !important;\n  color: #fff !important;\n}\n\n.btn-danger:hover {\n  background: #db1b2be8 !important;\n}\n\n// Approve\n.btn-approve {\n  background: #31df71 !important;\n  border-color: #18bb54 !important;\n  color: #000000 !important;\n}\n\n.btn-approve:hover {\n  background: #18bb54 !important;\n}\n\n.badgeExtra {\n  color: #1c1b1b !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n\n.btn:focus {\n  box-shadow: none !important;\n}\n\n.textSuccess{\n  color: #009a39;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.bg-success-wh {\n  background-color: #22c55e !important;\n}\n\n.bg-secondary-wh {\n  background-color: #bebbbb !important;\n}\n\n// Table Status\n.bg-table-status {\n  font-weight: 700;\n  padding: 4px;\n  border-radius: 50px;\n  width: 100%;\n  text-align: center;\n  // text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.bg-table-success-status {\n  color: #008000;\n  background-color: #228b223b;\n}\n\n.bg-table-danger-status {\n  color: #f30e2d;\n  background-color: #f30e2d3b;\n}\n\n.bg-table-warning-status {\n  color: #F17C1A;\n  background-color: #f17b1a42;\n}\n\n.bg-table-info-status {\n  color: #555555b2;\n  background-color: #55555523;\n}\n\n.bg-table-progress-status {\n  color: #FF8C00;\n  background-color: #ffbf0044;\n}\n\n.bg-table-new-status {\n  color: #002387;\n  background-color: #0024873b;\n}\n\n.bg-table-previous-approver-status {\n  color: #577766;\n  background-color: #85b09a42;\n}\n\n.bg-table-next-approver-status {\n  color: #3f7d99;\n  background-color: #89cff046;\n}\n\n.bg-table-documentNumber-status {\n  color: #fff;\n  background-color: #273167;\n}\n\n.bg-table-headerTag-status {\n  color: #3b2a6b;\n  background-color: #d7ddff;\n}\n\n// Workflow\n.bg-status {\n  font-weight: 700;\n  padding: 4px 16px;\n  border-radius: 50px;\n  width: 100%;\n  text-align: center;\n  letter-spacing: 0.5px;\n  margin-bottom: 4px;\n  // text-transform: uppercase;\n}\n\n.bg-success-workflow {\n  color: #008000;\n  background-color: #228b223b;\n}\n\n.bg-danger-workflow {\n  color: #f30e2d;\n  background-color: #f30e2d3b;\n}\n\n.bg-warning-workflow {\n  color: #F17C1A;\n  background-color: #f17b1a42;\n}\n\n.bg-info-workflow {\n  color: #555555b2;\n  background-color: #55555523;\n}\n\n.bg-pending-workflow {\n  color: #FF8C00;\n  background-color: #ffbf0044;\n}\n\n.bg-complete-workflow {\n  color: #fff;\n  background-color: #138808;\n}\n\n.bg-submit-workflow {\n  color: #007BA7;\n  background-color: #B9D9EB;\n}\n\n.bg-new-workflow {\n  color: #fff;\n  background-color: #008eff;\n}\n\n.headerStatusDetailedPage {\n  position: relative;\n  font-size: 16px;\n  padding: 5px 17px;\n  margin-left: 16px;\n  top: -4px;\n}\n\n.headerStatusTag {\n  position: relative;\n  font-size: 14px;\n  padding: 4px 16px;\n  margin-left: 16px;\n  letter-spacing: 1px;\n  border-radius: 6px;\n}\n\n\n.workflow-remark {\n  border: 1px solid #afa8a8;\n  padding: 10px;\n  border-radius: 5px;\n  border-style: dashed;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1c449c;\n}\n\n//radio button\n.form-check-input:checked {\n  background-color: var(--radio--background-color) !important;\n  border-color: var(--radio--border-color) !important;\n}\n\n// generatedTable\n.generatedTable {\n  width: 150% !important;\n\n  .tableHeader {\n    font-size: 12px;\n    font-weight: 700;\n    background-color: #f7f7f7;\n    letter-spacing: 1px;\n  }\n\n  ._01 {\n    width: 60px;\n    text-align: center;\n  }\n\n  ._02 {\n    width: 400px;\n  }\n\n  ._03 {\n    width: 150px;\n  }\n\n  ._04 {\n    width: 150px;\n  }\n\n  ._05 {\n    width: 150px;\n  }\n\n  td {\n    font-size: 13px;\n\n    .form-select {\n      font-size: 12px;\n    }\n  }\n}\n\n.autoScroll {\n  overflow: auto;\n}\n\n.tooltip-inner {\n  background-color: #fff !important;\n  color: #000 !important;\n  border: 1px solid #8c8f9580 !important;\n  max-width: 500px !important;\n  width: 300px !important;\n  font-size: 16px !important;\n  text-align: left !important;\n  box-shadow: 0px 0px 3px 0px gray;\n\n  p {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  .itemName {\n    font-size: 16px;\n    font-weight: 600;\n  }\n\n  .textPros {\n    font-size: 12px;\n    font-weight: 400;\n    text-align: right;\n  }\n\n  .rowBorder {\n    border-bottom: 1px dashed #858484;\n  }\n}\n\n.header-group {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.header-span {\n  font-weight: bold;\n  font-size: 16px;\n  padding: 5px;\n  background-color: #dcdcdc;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  text-align: center;\n  width: 200px;\n  /* Adjust width to simulate spanning columns */\n}\n\n.tooltip.show {\n  opacity: initial !important;\n}\n\n\n.ShowHorizontalStatus {\n  .activity-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: relative;\n  }\n\n  .activity-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n\n    .text-muted {\n      font-size: 12px;\n    }\n  }\n\n  .activity-line {\n    position: absolute;\n    top: 22px;\n    /* Adjust this based on icon size */\n    left: 80px;\n    right: 50px;\n    height: 2px;\n    background-color: #ccc;\n    /* Line color */\n    z-index: 0;\n  }\n\n  .activity-icon {\n    z-index: 1;\n    /* Ensure icons stay on top of the line */\n    background-color: white;\n    /* To give a border effect around the icon */\n  }\n\n  .activity-content {\n    text-align: center;\n\n    .text-break {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      font-size: 14px !important;\n    }\n\n  }\n\n\n}\n\n\n// Leftmenu\n.sidebar-nav .nav-heading {\n  font-size: 14px;\n  text-transform: uppercase;\n  color: #000000;\n  font-weight: 600;\n  margin: 12px 0 5px 0px;\n}\n\n// Event Details -> accordion\n.accordion-button:focus {\n  box-shadow: none !important;\n}\n\n.accordion-button:not(.collapsed) {\n  background-color: #ffffff !important;\n}\n\n.accordion-header {\n  margin-left: 0px;\n  margin-right: 0px;\n}\n\n.accordion-item {\n  .headerTitle {\n    display: block;\n    font-size: 17px;\n    font-weight: bold;\n    padding-bottom: 4px;\n  }\n\n  .subHeaderTitle {\n    display: block;\n    font-size: 14px;\n    font-weight: 400;\n  }\n}\n\n.accordion {\n  .refreshIcon {\n    width: 80px;\n    text-align: end;\n    font-size: 20px;\n    cursor: pointer;\n  }\n\n  .refreshIcon:hover {\n    font-size: 22px;\n  }\n\n  .dropdown-menu.show {\n    position: absolute !important;\n    inset: 30px 0px auto -122px !important;\n    margin: 0 !important;\n    transform: translate(0, 0) !important;\n  }\n}\n\n.commonFooter {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  color: #fff;\n  text-align: center;\n  padding: 20px 0;\n  margin-left: -2%;\n}\n\n.rowDirection {\n  flex-direction: row-reverse;\n}\n\n.headerIcon {\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.headerIcon:hover {\n  color: #ceaef7;\n}\n\n.iconLogo {\n  background: var(--table-icon-background-color) !important;\n  font-size: 20px;\n  color: var(--table-icon-text-color);\n  border: 1px solid rgba(0, 0, 0, 0.11);\n  border-radius: 4px;\n  width: 44px;\n  display: block;\n  padding: 5px 0px;\n}\n\n// Common cards color\n// .card {\n//   // background-image: linear-gradient(181deg, #ffffff, #f3eded, #e8e3e3) !important;\n//   background-image: linear-gradient(181deg,\n//       #ffffff,\n//       #efefef,\n//       #f3eded) !important;\n//   border: 1px solid #e7e1e1cf !important;\n// }\n\n\n// Common input textfield color\ninput[type=\"text\"],\ninput[type=\"number\"],\ninput[type=\"date\"],\ninput[type=\"password\"],\ninput[type=\"email\"] {\n  background-color: #ffffffe3 !important;\n  border-radius: 8px !important;\n  font-size: 14px !important;\n  border: 1px solid #ccc;\n}\n\n// Common font style and color\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nspan,\nlabel,\na,\ndiv {\n  font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\",\n    \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\",\n    \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !important;\n  color: var(--app-text-color);\n}\n\n.dropdownHive {\n  input[type=text] {\n    // background-color: transparent !important;\n    border-radius: 2px !important;\n    font-size: 14px !important;\n    border: 0px solid rgb(195, 185, 185) !important;\n  }\n\n  .rw-widget-picker {\n    min-height: 42px;\n    border-radius: 8px;\n  }\n\n  .rw-list-option.rw-state-selected,\n  .rw-state-selected.rw-list-option-create {\n    background-color: #aaa8a8;\n    border-color: #aaa8a8;\n    color: #fff;\n  }\n}\n\n.border-red-dropdown{\n  .rw-widget-picker{\n    border: 1px solid rgb(248, 5, 5) !important;\n  }\n}\n\n.dropdownHiveOption {\n  z-index: 9999;\n}\n\n.dropdownIcon {\n  top: 23px;\n}\n\n.form-label {\n  font-weight: 600;\n  font-size: 14px;\n}\n\na {\n  text-decoration: none !important;\n}\n\n// a:hover{\n//   color: #6476d9  !important;\n// }\n.subText {\n  font-size: 14px;\n}\n\n.form-signin {\n  text-align: center;\n  margin-top: 22px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.text-indigo-600 {\n  --tw-text-opacity: 1;\n  color: rgb(79 70 229 / var(--tw-text-opacity)) !important;\n}\n\n/* width */\n::-webkit-scrollbar {\n  width: 4px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #bec4c4;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* ===== Scrollbar CSS ===== */\n/* Firefox */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #bebbbb #ffffff;\n}\n\n/* Chrome, Edge, and Safari */\n*::-webkit-scrollbar {\n  width: 4px;\n}\n\n*::-webkit-scrollbar-track {\n  background: #ffffff;\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: #bebbbb;\n  border-radius: 10px;\n  border: 3px solid #ffffff;\n}\n\n.arrowBtn {\n  width: 50px !important;\n}\n\n.logoBtn {\n  width: 70px !important;\n}\n\n// Header and Line Item Display Screen\n.headerText {\n  font-weight: 600;\n  font-size: 16px;\n  margin-right: 4px;\n  display: block;\n}\n\n.headerSubText {\n  font-size: 16px;\n}\n\n.deleteIconAccordion {\n  float: inline-end;\n  margin-top: -54px;\n  margin-right: 15px;\n  i {\n    font-size: 24px;\n    color: red;\n    cursor: pointer;\n  }\n\n  i:hover {\n    font-size: 26px;\n  }\n}\n\n.infoIconAccordion {\n  i {\n    font-size: 18px;\n    color: rgb(24, 33, 121);\n    cursor: pointer;\n  }\n}\n\n.dynamicDropdown {\n  .rw-popup-container {\n    padding: 0px !important;\n    position: static !important;\n  }\n}\n\n.numberFormate {\n  width: 100%;\n  text-align: end;\n}\n\n\n// Common Ends here\n// ------------------------------------------------------------------------- //\n\n.sectionArea {\n  box-shadow: 0px 20px 40px 9px rgba(0, 0, 0, 0.295);\n}\n\n.navMenu {\n  font-weight: 400 !important;\n  text-transform: uppercase;\n}\n\n.supplier_app {\n  font-family: sans-serif, \"Helvetica Neue\", \"Lucida Grande\", Arial;\n  font-size: 34px;\n}\n\n.feature {\n  .learnMore {\n    padding: 7px;\n    background: #ff3434;\n    color: #ffffff;\n    font-weight: 600;\n    letter-spacing: 1px;\n  }\n\n  .textBox {\n    border-left-width: 18px;\n    height: 325px;\n    padding-top: 35px;\n    margin-right: 7%;\n    padding-left: 38px;\n    text-align: justify;\n  }\n}\n\n.h2 {\n  margin-top: 0;\n  margin-bottom: 25px;\n  font-size: 60px;\n  line-height: 120%;\n  color: #e3f2ff;\n\n  .headline-emphasis-red {\n    color: #e04b4d;\n    font-family: Georgia, Times, Times New Roman, serif;\n    font-style: italic;\n    font-weight: 400;\n  }\n}\n\n.cta {\n  margin-top: 0;\n  margin-bottom: 25px;\n  font-size: 40px;\n  line-height: 120%;\n\n  .headline-emphasis-gold {\n    color: #c4a27f;\n    font-family: Georgia, Times, Times New Roman, serif;\n    font-style: italic;\n    font-weight: 400;\n  }\n}\n\n.staffed {\n  margin-top: 0;\n  margin-bottom: 25px;\n  font-size: 45px;\n  line-height: 160%;\n  color: #410641;\n}\n\n.ctaFindButton {\n  background-color: #fb00009c !important;\n}\n\n.ctaFindButton:hover {\n  background-color: #ff0000 !important;\n}\n\n.text-lgColor {\n  color: #71b7b7;\n}\n\n.text-xlColor {\n  color: #f7f7f7;\n}\n\n// Footer\n.footer {\n  .workersHiveFooter {\n    text-align: right;\n    position: absolute;\n    padding-top: 1%;\n  }\n}\n\n// Navbar\n.navBackground {\n  background-color: #131834;\n}\n\n.introCustomerlogo{\n  width: 150px;\n  height: 70px !important;\n}\n\n// Login\n.loginPage {\n  background-color: #ffffff;\n  background-image: -webkit-linear-gradient(278deg, #f3f3f3 65%, #ffffff 50%);\n\n  .loadSingIn {\n    animation: bounce-in 1s ease-in;\n  }\n\n  .loadReset {\n    animation: bounce-out 1s ease-in;\n  }\n\n  @keyframes bounce-in {\n    0% {\n      opacity: 0;\n      transform: scale(0.5);\n    }\n\n    100% {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n\n  @keyframes bounce-out {\n    0% {\n      opacity: 1;\n      transform: scale(1);\n    }\n\n    100% {\n      opacity: 0;\n      transform: scale(0.5);\n    }\n  }\n\n  .indexValue {\n    z-index: 5;\n  }\n\n  .mainTitle {\n    font-weight: 700;\n    letter-spacing: 1px;\n    margin-bottom: 18px;\n    margin-top: 15px;\n    color: #dc0000;\n    text-align: center;\n  }\n\n  .box2 {\n    border: 1px solid #dbd6d6;\n    border-radius: 3px;\n    box-shadow: 0px 7px 20px 3px #b7b6b6;\n    padding: 40px 40px 30px 40px;\n\n    .inputBox {\n      padding-left: 10px;\n    }\n\n    .eyeCss {\n      margin-top: 12px;\n      width: 30px;\n    }\n\n    .mainTitleBox2 {\n      font-size: 20px;\n      color: #313131;\n      margin-top: 6px;\n    }\n\n    .passwordEye {\n      position: absolute;\n      margin-left: -28px;\n      margin-top: 18px;\n    }\n  }\n\n  .footer {\n    margin-top: 0%;\n    float: left;\n    font-size: 14px;\n    font-weight: 600;\n\n    .footerLink {\n      text-decoration: none;\n      color: #2b2a2a;\n      margin-right: 14px;\n    }\n\n    .footerLinkText {\n      margin: 8px 13px 13px 2px;\n      font-size: 12px;\n      font-weight: 500;\n    }\n  }\n\n  .subText {\n    font-size: 13px;\n  }\n\n  .staySingIn {\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  .removeUnderline {\n    cursor: pointer;\n    text-decoration: none;\n    font-size: 14px;\n    font-weight: 600;\n    color: #0d6efd;\n    float: right;\n    margin-top: -21px;\n  }\n\n  .removeUnderline:hover {\n    color: rgb(220 0 0);\n  }\n\n  .singUp {\n    cursor: pointer;\n    text-decoration: none;\n    font-size: 14px;\n    font-weight: 600;\n    color: #0d6efd;\n  }\n\n  .singUp:hover {\n    color: rgb(220 0 0);\n  }\n\n  .returnSingIn {\n    cursor: pointer;\n    text-align: center;\n    margin-top: 25px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #0d6efd;\n  }\n\n  .returnSingIn:hover {\n    color: rgb(220 0 0);\n  }\n\n  .db-RegisterAndLoginBackground-background {\n    z-index: 0;\n    position: absolute;\n    top: 530px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    transform: skewY(352deg);\n\n    .db-RegisterAndLoginBackground-firstLeftStripe {\n      background: rgb(220 0 0 / 78%);\n      height: 40px;\n      top: 668px;\n      left: calc(50% - 700px);\n      right: calc(50% + 540px);\n    }\n\n    .db-RegisterAndLoginBackground-secondLeftStripe {\n      background: rgb(13 0 255 / 37%);\n      height: 16px;\n      top: 698px;\n      left: -10px;\n      right: calc(50% + 405px);\n    }\n  }\n}\n\n.mailConfirmation {\n  // background-color: #ffffff;\n  // background-image: -webkit-linear-gradient(275deg, #f3f3f3 65%, #ffffff 50%);\n\n  .confirmIcon {\n    font-size: 100px;\n    position: absolute;\n    color: #00d700;\n    margin-top: -56px;\n    margin-left: -42px;\n  }\n\n  .mainTitle {\n    font-weight: 700;\n    letter-spacing: 1px;\n    margin-bottom: 18px;\n    margin-top: 15px;\n    color: #dc0000;\n    text-align: center;\n  }\n\n  .box2 {\n    border: 1px solid #dbd6d6;\n    border-radius: 3px;\n    box-shadow: 0px 7px 20px 3px #b7b6b6;\n    padding: 90px 40px 30px 40px !important;\n\n    .mainContent {\n      text-align: center;\n      font-size: 26px;\n      font-weight: bold;\n    }\n\n    .subContent {\n      text-align: center;\n      font-size: 15px;\n      font-weight: 600;\n      margin-bottom: 32px;\n    }\n\n    .inputBox {\n      padding-left: 10px;\n    }\n\n    .eyeCss {\n      margin-top: 12px;\n      width: 30px;\n    }\n\n    .mainTitleBox2 {\n      font-size: 20px;\n      color: #313131;\n      margin-top: 6px;\n    }\n\n    .passwordEye {\n      position: absolute;\n      margin-left: -28px;\n      margin-top: 18px;\n    }\n  }\n\n  .footer {\n    margin-top: 30px;\n    float: left;\n    font-size: 14px;\n    font-weight: 600;\n\n    .footerLink {\n      text-decoration: none;\n      color: #2b2a2a;\n      margin-right: 14px;\n    }\n\n    .footerLinkText {\n      margin: 8px 13px 13px 2px;\n      font-size: 12px;\n      font-weight: 500;\n    }\n  }\n\n  .db-RegisterAndLoginBackground-background {\n    z-index: 0;\n    position: absolute;\n    top: 530px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    transform: skewY(352deg);\n\n    .db-RegisterAndLoginBackground-firstLeftStripe {\n      background: rgb(220 0 0 / 78%);\n      height: 40px;\n      top: 668px;\n      left: calc(50% - 700px);\n      right: calc(50% + 540px);\n    }\n\n    .db-RegisterAndLoginBackground-secondLeftStripe {\n      background: rgb(13 0 255 / 37%);\n      height: 16px;\n      top: 698px;\n      left: -10px;\n      right: calc(50% + 405px);\n    }\n  }\n}\n\n// Register\n.registerPage {\n\n  // padding-top: 50px;\n  // background-color: #ffffff;\n  // background-image: -webkit-linear-gradient(278deg, #f3f3f3 65%, #ffffff 50%);\n  .fieldErrMsg {\n    font-size: 12px;\n    color: #f32525 !important;\n  }\n\n  .indexValue {\n    z-index: 5;\n  }\n\n  .logo {\n    width: 150px;\n  }\n\n  .mainTitle {\n    font-weight: 700;\n    letter-spacing: 1px;\n    margin-bottom: 30px;\n    margin-top: -36px;\n  }\n\n  .mainTitleSm {\n    font-weight: 700;\n    letter-spacing: 1px;\n    margin-bottom: 32px;\n    margin-top: 40px;\n    color: #dc0000;\n    text-align: center;\n  }\n\n  .box1 {\n    .boxTitle {\n      font-size: 16px;\n      font-weight: 600;\n      margin-top: 7px;\n    }\n\n    .subBoxTitle {\n      font-size: 14px;\n      font-weight: 500;\n    }\n  }\n\n  .box2 {\n    border: 1px solid #dbd6d6;\n    border-radius: 3px;\n    box-shadow: 0px 7px 20px 3px #b7b6b6;\n    padding: 40px 40px 30px 40px;\n\n    .inputBox {\n      padding-left: 10px;\n    }\n\n    .eyeCss {\n      margin-top: 12px;\n      width: 30px;\n    }\n\n    .mainTitleBox2 {\n      color: #313131;\n      margin-top: 6px;\n    }\n  }\n\n  .footer {\n    margin-top: 12%;\n    float: left;\n    font-size: 14px;\n    font-weight: 600;\n\n    .footerLink {\n      text-decoration: none;\n      color: #2b2a2a;\n      margin: 13px;\n    }\n\n    .footerLinkText {\n      margin: 3px 13px 13px 15px;\n      font-size: 12px;\n      font-weight: 500;\n    }\n  }\n\n  .singIn {\n    text-decoration: none;\n  }\n\n  .db-RegisterAndLoginBackground-background {\n    z-index: 0;\n    position: absolute;\n    top: 530px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    transform: skewY(352deg);\n\n    .db-RegisterAndLoginBackground-firstLeftStripe {\n      background: rgb(220 0 0 / 78%);\n      height: 40px;\n      top: 668px;\n      left: calc(50% - 700px);\n      right: calc(50% + 540px);\n    }\n\n    .db-RegisterAndLoginBackground-secondLeftStripe {\n      background: rgb(13 0 255 / 37%);\n      height: 16px;\n      top: 698px;\n      left: -10px;\n      right: calc(50% + 405px);\n    }\n  }\n}\n\n//Loader\n/* 3D tower loader made by: csozi | Website: www.csozi.hu*/\n\n.dots-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  margin-top: 150px;\n}\n\n.dot {\n  height: 20px;\n  width: 20px;\n  margin-right: 10px;\n  border-radius: 10px;\n  background-color: #b3d4fc;\n  animation: pulse 1.5s infinite ease-in-out;\n}\n\n.dot:last-child {\n  margin-right: 0;\n}\n\n.dot:nth-child(1) {\n  animation-delay: -0.3s;\n}\n\n.dot:nth-child(2) {\n  animation-delay: -0.1s;\n}\n\n.dot:nth-child(3) {\n  animation-delay: 0.1s;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(0.8);\n    background-color: #b3d4fc;\n    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);\n  }\n\n  50% {\n    transform: scale(1.2);\n    background-color: #6793fb;\n    box-shadow: 0 0 0 10px rgba(178, 212, 252, 0);\n  }\n\n  100% {\n    transform: scale(0.8);\n    background-color: #b3d4fc;\n    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);\n  }\n}\n\n.accordion {\n  .accordion-header {\n\n    .bi-chevron-right,\n    .bi-chevron-down {\n      font-size: 24px;\n      cursor: pointer;\n    }\n  }\n\n  .accordion-collapse {\n    display: none;\n    transition: all 0.5s ease-in-out;\n  }\n\n  .accordion-collapse.visible {\n    display: block;\n    transition: all 0.5s ease-in-out;\n  }\n}\n\n// Dashboard Filter\n.filterIcon{\n  font-size: 45px;\n  justify-content: flex-end;\n  display: flex;\n  color: #008ffb;\n  cursor: pointer;\n}\n.filterIcon:hover{\n  font-size: 46px;\n  color: #034679;\n}\n.filterBox{\n  border: 1px solid #8c8686;\n  border-radius: 8px;\n  padding: 18px 16px 0px 16px;\n  border-style: dashed;\n  margin-bottom: 20px;\n  background-color: #ffffff;\n  box-shadow: 0px 1px 9px 1px #b7b7b7;\n}\n.dashboard-navigate-icon{\n  font-size: 32px;\n  position: absolute;\n  top: 96px;\n  right: 10px;\n  color: #3457D5;\n  cursor: pointer;\n}\n.dashboard-navigate-icon:hover{\n  color: #318CE7;\n}\n\n// Dashboard Loader\n.loader-small{\n  .loader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n  }\n  \n  .loader__circle {\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    margin: 0 4px;\n    animation: loader_901 1s ease-in-out infinite;\n  }\n  \n  .loader__circle:nth-of-type(1) {\n    background-color: #007aff;\n    animation-delay: 0;\n  }\n  \n  .loader__circle:nth-of-type(2) {\n    background-color: #ff2d55;\n    animation-delay: 0.25s;\n  }\n  \n  .loader__circle:nth-of-type(3) {\n    background-color: #34c759;\n    animation-delay: 0.5s;\n  }\n  \n  .loader__circle:nth-of-type(4) {\n    background-color: #ff9500;\n    animation-delay: 0.75s;\n  }\n  \n  @keyframes loader_901 {\n    0% {\n      transform: scale(1);\n    }\n  \n    20% {\n      transform: scale(1.2);\n    }\n  \n    40% {\n      transform: scale(1);\n    }\n  }  \n}\n\n.fileUploadedList{\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  background-color: #b7dbff;\n  padding: 2px 10px;\n  border-radius: 16px;\n}\n\n.fileRemoveIcon{\n  font-size: 18px;\n  cursor: pointer;\n  color: #ff0000;\n}\n\n.fileChoose{\n  margin-bottom: 8px;\n  border: 1px solid rgba(195, 185, 185, 0.568627451);\n  padding: 8px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n.fileChoose:hover{\n  background-color: #dae6f3;\n}\n\n.fileChooseDisabled{\n  margin-bottom: 8px;\n  border: 1px solid rgba(195, 185, 185, 0.568627451);\n  padding: 8px;\n  border-radius: 8px;\n  background-color: #e9ecef;\n}\n.fileDownload{\n  font-size: 20px;\n  float: right;\n  margin-right: 36px;\n}\n\n.pac-container {\n  width: 100% !important; /* Full width inside its parent */\n  max-width: 594px !important; /* Limit max width */\n  position: absolute !important;\n  // top: 100% !important; /* Position it just below the input field */\n  // left: 0 !important; /* Align to the left */\n  left: 877px !important;\n  top: 2030px !important;\n  z-index: 9999; /* Ensure it appears on top */\n  background-color: white; /* White background for better visibility */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* Subtle shadow */\n  border-radius: 4px; /* Slight rounding of edges */\n  padding: 10px; /* Padding for better content spacing */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
